// ===================================
// KAIXO - Guía de Impulsa (antes "Información" del ImpulsaModal)
// Componente reutilizable: se embebe dentro del hub Impulsa.
// ===================================

import React from 'react';
import { Icons } from '../Icons/Icons';
import ct from './i18n';
import './Impulsa.css';

function ImpulsaGuide() {
    return (
        <div className="imp-body" style={{ padding: 0 }}>
            <div className="imp-info-section">
                <h3><Icons.Pulse size={16} /> {ct.whatIsImpulsa}</h3>
                <p>{ct.whatIsImpulsaText}</p>
            </div>

            <div className="imp-info-section">
                <h3><Icons.Star size={16} /> {ct.plansSection}</h3>
                <p>{ct.plansText}</p>
            </div>

            <div className="imp-info-section">
                <h3><Icons.Users size={16} /> {ct.crmSection}</h3>
                <p>{ct.crmText}</p>
            </div>

            <div className="imp-info-section">
                <h3><Icons.Globe size={16} /> {ct.targetingSection}</h3>
                <p>{ct.targetingText}</p>
            </div>

            <div className="imp-info-section">
                <h3><Icons.Heart size={16} /> {ct.interestsSection}</h3>
                <p>{ct.interestsText}</p>
            </div>

            <div className="imp-info-section">
                <h3># {ct.hashtagsSection}</h3>
                <p>{ct.hashtagsText}</p>
            </div>

            <div className="imp-info-section">
                <h3><Icons.Link size={16} /> {ct.friendlyUrlSection}</h3>
                <p>{ct.friendlyUrlText}</p>
            </div>

            <div className="imp-info-section imp-info-highlight">
                <h3>🚀 {ct.smartAlgorithmSection}</h3>
                <p style={{ whiteSpace: 'pre-line' }}>{ct.smartAlgorithmText}</p>
            </div>

            <div className="imp-info-section">
                <h3>💡 {ct.tipsTitle}</h3>
                <ul className="imp-tips">
                    {(ct.tips || []).map((t, i) => (
                        <li key={i}><strong>{t[0]}</strong> — {t[1]}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default ImpulsaGuide;
